import { ApiBO } from '@Arti-zen/package-backoffice'

export const ApiArtizenBO = new ApiBO({
  urlBackend: process.env.REACT_APP_BACKOFFICE_URL,
  userAgent: 'webAdmin',
})
